import { SvgIcon, SvgIconProps } from '@mui/material';

const Info = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9997 11.7036V18.1851M12.9997 24.6666C6.55635 24.6666 1.33301 19.4432 1.33301 12.9999C1.33301 6.5566 6.55635 1.33325 12.9997 1.33325C19.443 1.33325 24.6663 6.5566 24.6663 12.9999C24.6663 19.4432 19.443 24.6666 12.9997 24.6666ZM13.0642 7.81473V7.94436L12.9351 7.94462V7.81473H13.0642Z"
        stroke="#447AED"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export default Info;
